export default "__VITE_ASSET__ClGcKN8y__"